import postList from './post-list';

export default {
	postList
};
